/**
 * BELVOIR MOTION — Savor polish layer
 * Subtle fade-up reveals on scroll with per-card stagger.
 * Design principles:
 *   - Content is never hidden without JS: styles only apply under html.bv-motion.
 *   - Respects prefers-reduced-motion (CSS side disables transitions).
 *   - Theme-editor aware: re-scans on shopify:section:load.
 *   - Above-the-fold content reveals immediately (no first-paint flash).
 */

(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.BV && window.BV.motion === false) return;

  var STAGGER_MS = (window.BV && typeof window.BV.stagger === 'number') ? window.BV.stagger : 70;
  var STAGGER_MAX = 6; /* cap so long grids don't crawl */

  var TARGET_SELECTORS = [
    '.product-grid__item',
    '.resource-list__item',
    '.collection-card',
    '.section-resource-list__header',
    '.section h2',
  ].join(',');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bv-inview');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function prepare(root) {
    var nodes = (root || document).querySelectorAll(TARGET_SELECTORS);
    var groupCounters = new WeakMap();

    nodes.forEach(function (el) {
      if (el.classList.contains('bv-reveal')) return;

      /* Stagger siblings within the same parent (grids, carousels) */
      var parent = el.parentElement;
      var idx = 0;
      if (parent) {
        idx = groupCounters.get(parent) || 0;
        groupCounters.set(parent, idx + 1);
      }
      el.style.setProperty('--bv-delay', Math.min(idx, STAGGER_MAX) * STAGGER_MS + 'ms');
      el.classList.add('bv-reveal');

      /* Already in viewport (above the fold): reveal on next frame, no scroll needed */
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.add('bv-inview'); });
        });
      } else {
        observer.observe(el);
      }
    });
  }

  function boot() {
    document.documentElement.classList.add('bv-motion');
    prepare(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: sections re-render in place */
  document.addEventListener('shopify:section:load', function (e) {
    prepare(e.target);
  });
})();
